import React, { useState, useEffect, useRef } from 'react';


export default function IterateController({ uuid }) {
    const [currentIteration, setCurrentIteration] = useState(0);

    const addIteration = () => {
        setCurrentIteration(prevIteration => prevIteration + 1);
    };

    return (
        <>  
        </>
    );
}